import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
    },

    {
      path: '/branches',
      name: 'branches',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "management" */ './views/Branches.vue'),
    },
    {
      path: '/customer-care',
      name: 'customer-care',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "management" */ './views/CustomerCare.vue'),
    },
    {
      path: '/about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About/Index.vue'),
      children: [
        {
          path: '/about/board-of-directors',
          name: 'board_of_directors',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "boardofdirectors" */ './views/About/BoardOfDirectors.vue'),
        },
        {
          path: '',
          name: 'about-info',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "aboutinfo" */ './views/About/Info.vue'),
        },
        {
          path: '/about/management',
          name: 'management',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "management" */ './views/About/Management.vue'),
        },

        {
          path: '/about/shareholders',
          name: 'shareholders',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "shareholders" */ './views/About/Shareholders.vue'),
        },
        {
          path: '/about/organizational-structure-of-the-bank',
          name: 'organizational-structure-of-the-bank',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "organizationalstructureofbank" */ './views/About/OrganizationalStructureOfTheBank.vue'),
        },
        {
          path: '/about/mission-and-vision',
          name: 'mission_and_vision',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "missionandvision" */ './views/About/MissionAndVision.vue'),
        },
      ],
    },
    {
      path: '/human-resources',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "human-resources" */ './views/HumanResources/Index.vue'),
      children: [
        {
          path: '',
          name: 'recruting',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "recruting" */ './views/HumanResources/Recruting.vue'),
        },
        {
          path: '/human-resources/practical-work',
          name: 'practical-work',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "practicalwork" */ './views/HumanResources/PracticalWork.vue'),
        },
        {
          path: '/human-resources/work-opportunities',
          name: 'work-opportunities',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "workopportunities" */ './views/HumanResources/WorkOpportunities.vue'),
        },
      ],
    },
    {
      path: '/partners',
      name: 'partners',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "partners" */ './views/Partners.vue'),
    },
    {
      path: '/services',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "services" */ './views/Services/Index.vue'),
      children: [
        {
          path: '/services/documents/business',
          name: 'business',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "business" */ './views/Services/Documents/Business.vue'),
        },
        {
          path: '/services/documents/individual',
          name: 'individual',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "individual" */ './views/Services/Documents/Individual.vue'),
        },
        {
          path: '/services/documents/individual-business',
          name: 'individual-business',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "individual-business" */ './views/Services/Documents/IndividualBusiness.vue'),
        },
        {
          path: '/services/individual/cash',
          name: 'individual-cash',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "individual-cash" */ './views/Services/Individual/Cash.vue'),
        },
        {
          path: '/services/individual/cars',
          name: 'individual-cars',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "individualCars" */ './views/Services/Individual/Cars.vue'),
        },
        {
          path: '/services/individual/mortgage',
          name: 'individual-mortgage',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "individualMortgage" */ './views/Services/Individual/Mortgage.vue'),
        },
        {
          path: '/services/individual/other',
          name: 'individual-other',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "individual-other" */ './views/Services/Individual/Other.vue'),
        },
        {
          path: '/services/individual/renovation',
          name: 'renovation',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "renovation" */ './views/Services/Individual/Renovation.vue'),
        },
        {
          path: '/services/business/assets-financing',
          name: 'assets-financing',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "AssetsFinancing" */ './views/Services/Business/AssetsFinancing.vue'),
        },
        {
          path: '/services/business/goods-financing',
          name: 'goods-financing',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "GoodsFinancing" */ './views/Services/Business/GoodsFinancing.vue'),
        },
        {
          path: '/services/business/mortgage-financing',
          name: 'mortgage-financing',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "MortgageFinancing" */ './views/Services/Business/MortgageFinancing.vue'),
        },
        {
          path: '/services/business/other',
          name: 'business-other',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "BusinessOther" */ './views/Services/Business/Other.vue'),
        },
      ],
    },
    {
      path: '/news',
      name: 'news',
      component: () => import(/* webpackChunkName: "news" */ './views/News.vue'),
    },
    {
      name: 'new',
      path: '/news/:id',
      props: true,
      component: () => import(/* webpackChunkName: "new" */ './views/New.vue'),
    },
    {
      name: 'contact',
      path: '/contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue'),
    },
    {
      name: 'search',
      path: '/search',
      component: () => import('./views/Search.vue'),
    },
    {
      name: 'apply-for-loan',
      path: '/apply-for-loan',
      component: () => import('./views/ApplyForLoan.vue'),
    },
    {
      name: 'success-view',
      path: '/application-success',
      component: () => import('./views/Success.vue'),
    },
  ],
});
